import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ConstantProvider {
    public ROL_ADMIN = 'admin';
    public ROL_NORMAL_USER = 'normal_user';
    public ROL_COMMUNITY_MANAGER = 'community_manager';
    public ROL_CUSTOMER_VISUALIZER = 'customer_visualizer';

    //Colors
    public COLOR_ORANGE = '#DD6B20';
    public COLOR_GREEN = '#28a745';
    public COLOR_PURPLE = '#805AD5';
    public COLOR_BLUE = '#3182CE';
    public COLOR_YELLOW = '#fbbf24';
    public COLOR_RED = '#f94144';

    public COLOR_LIGHT_ORANGE = '#f3722c';
    public COLOR_LIGHT_GREEN = '#90be6d';
    public COLOR_LIGHT_YELLOW = '#f9c74f';

    public COLOR_DARK_BLUE = '#6366f1';

    //Reports titles
    public TITLE_ADMIN_HOME_REPORT = "Reporte General";
    public TITLE_ACTIVITY_REPORT = "Reporte de Actividades";
    public TITLE_TRANSACTION_REPORT = "Reporte de Transacciones";
    public TITLE_INVENTARY_REPORT = "Reporte de inventario";
    public TITLE_USAGE_REPORT = "Reporte de uso";
}
